// extracted by mini-css-extract-plugin
module.exports = {"body":"leaderboard_body__xlDle"};